// Fetch actions
export const CLEAR_PLAYER_DATA = "CLEAR_PLAYER_DATA";
export const GET_PROJECTS = "GET_PROJECTS";
export const GET_SMARTLISTS = "GET_SMARTLISTS";
export const GET_GIFTS = "GET_GIFTS";
export const GET_OFFERS = "GET_OFFERS";
export const GET_OFFER = "GET_OFFER";
export const GET_CONTENTS = "GET_CONTENTS";
export const GET_CONTENT = "GET_CONTENT";
export const GET_COMPONENTS = "GET_COMPONENTS";
export const GET_CASTING = "GET_CASTING";
export const GET_CASTINGS = "GET_CASTINGS";
export const GET_METADATAS = "GET_METADATAS";
export const GET_SOURCE_MEDIAS = "GET_SOURCE_MEDIAS";
export const GET_LANGUAGES = "GET_LANGUAGES";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_HOSTED_STREAMS = "GET_HOSTED_STREAMS";
export const GET_DEPLOYMENT_STATUSES = "GET_DEPLOYMENT_STATUSES";
export const GET_PLAYER_URL = "GET_PLAYER_URL";
export const GET_ORGA_CONFIG = "GET_ORGA_CONFIG";
export const GET_OFFER_STATS = "GET_OFFER_STATS";
export const GET_OFFER_PLANS = "GET_OFFER_PLANS";
export const GET_SUM_MEDIA_VIEWS = "GET_SUM_MEDIA_VIEWS";
export const GET_MEDIA_STATUS = "GET_MEDIA_STATUS";
export const GET_OFFER_USERS = "GET_OFFER_USERS";
export const GET_OFFER_USERS_FREECOPY = "GET_OFFER_USERS_FREECOPY";
export const GET_UNSUBSCRIBER_TRANSACTIONS = "GET_UNSUBSCRIBER_TRANSACTIONS";
export const GET_USER_SUBSCRIPTIONS = "GET_USER_SUBSCRIPTIONS";
export const GET_USER_PURCHASES = "GET_USER_PURCHASES";
export const GET_FILTERED_USERS = "GET_FILTERED_USERS";
export const GET_EDUS = "GET_EDUS";
export const GET_USER = "GET_USER";
export const GET_EDU_USER = "GET_EDU_USER";
export const GET_STANDARD_USER = "GET_STANDARD_USER";
export const GET_USER_STATUS = "GET_USER_STATUS";
export const GET_USERS = "GET_USERS";
export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_OPTIONS = "GET_PLANS_OPTIONS";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const GET_PURCHASES_VIDEOS = "GET_PURCHASES_VIDEOS";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_VIDEOS = "GET_SUBSCRIPTIONS_VIDEOS";
export const GET_PURCHASES = "GET_PURCHASES";

// PUT actions
export const UPDATE_COMPONENT = "UPDATE_COMPONENT";
export const CREATE_COMPONENT = "CREATE_COMPONENT";
export const UPDATE_CONTENT = "UPDATE_CONTENT";
export const CREATE_CONTENT = "CREATE_CONTENT";
export const UPLOAD_IMAGE_CONTENT = "UPLOAD_IMAGE_CONTENT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const CREATE_PROJECT = "CREATE_PROJECT";
export const UPDATE_GIFT = "UPDATE_GIFT";
export const CREATE_GIFT = "CREATE_GIFT";
export const CREATE_KEYWORD = "CREATE_KEYWORD";
export const CREATE_REPLAY = "CREATE_REPLAY";
export const CREATE_COPYRIGHT = "CREATE_COPYRIGHT";
export const CREATE_ENCODING = "CREATE_ENCODING";
export const CREATE_CASTING = "CREATE_CASTING";
export const UPDATE_EDU = "UPDATE_EDU";
export const CREATE_EDU = "CREATE_EDU";
export const UPDATE_USER = "UPDATE_USER";
export const CREATE_USER = "CREATE_USER";
export const CREATE_EDITOR_USER = "CREATE_EDITOR_USER";
export const PAYEMENT_PROCESS = "PAYEMENT_PROCESS";
export const CONFIRM_PAYEMENT = "CONFIRM_PAYEMENT";
export const UPDATE_BULK = "UPDATE_BULK";
export const CANCEL_USER_SUBSCRIPTION = "CANCEL_USER_SUBSCRIPTION";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_COMMENTS = "UPDATE_COMMENTS";

// Post actions
export const ASK_RESET_PASSWORD = "ASK_RESET_PASSWORD";
export const ADD_MEDIA = "ADD_MEDIA";

// DELETE actions
export const DELETE_COMPONENT = "DELETE_COMPONENT";
export const DELETE_SOURCE_MEDIA = "DELETE_SOURCE_MEDIA";
export const DELETE_STREAM = "DELETE_STREAM";
export const DELETE_BULK = "DELETE_BULK";
export const DELETE_MEDIA = "DELETE_MEDIA";
export const DELETE_COMMENTS = "DELETE_COMMENTS";
export const DELETE_EDU = "DELETE_EDU";
export const DELETE_USER = "DELETE_USER";

// Media actions
export const UPLOAD_MEDIA_LINK = "UPLOAD_MEDIA_LINK";

// Pagination actions
export const SET_PAGE = "SET_PAGE";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
export const SET_SORT = "SET_SORT";
export const SET_FILTERS = "SET_FILTERS";
export const SEARCH_TEXT = "SEARCH_TEXT";
export const RESET_ALL_FILTERS = "RESET_ALL_FILTERS";

// Void action, it should not be used in the reducers
export const VOID_ACTION = "VOID_ACTION";

// Login action
export const RESET_AUTH = "RESET_AUTH";
export const SET_EDITOR_AUTH = "SET_EDITOR_AUTH";

// CLEAR DATA in the reducers
export const CLEAR_DATA = "CLEAR_DATA";

// 2FA actions
export const SETUP_2FA = "SETUP_2FA";
export const DISABLE_2FA = "DISABLE_2FA";
export const VALIDATE_2FA = "VALIDATE_2FA";

// Variable actions
export const SET_FREECOPY_TOKEN = "SET_FREECOPY_TOKEN";
export const SET_GIFT_TOKEN = "SET_GIFT_TOKEN";
export const SET_LOCALE = "SET_LOCALE";

// Player actions
export const START_PLAYER = "START_PLAYER";
export const STOP_PLAYER = "STOP_PLAYER";
export const OPEN_PLAYER_BOX = "OPEN_PLAYER_BOX";
export const CLOSE_PLAYER_BOX = "CLOSE_PLAYER_BOX";
export const MINIMIZE_PLAYER_BOX = "MINIMIZE_PLAYER_BOX";
export const MAXIMIZE_PLAYER_BOX = "MAXIMIZE_PLAYER_BOX";
export const SHOW_PLAYER_PIP = "SHOW_PLAYER_PIP";
export const HIDE_PLAYER_PIP = "HIDE_PLAYER_PIP";
export const TOGGLE_PLAYER_PIP = "TOGGLE_PLAYER_PIP";
export const PLAYLIST_NEXT_MEDIA = "PLAYLIST_NEXT_MEDIA";
export const PLAYLIST_PREVIOUS_MEDIA = "PLAYLIST_PREVIOUS_MEDIA";

// Architecture actions
export const SET_ARCHITECTURE = "SET_ARCHITECTURE";
export const RESET_ARCHITECTURE = "RESET_ARCHITECTURE";
export const SET_PROJECT_UUID = "SET_PROJECT_UUID";
export const SET_PROJECT = "SET_PROJECT";
export const SET_STRIPE_KEY = "SET_STRIPE_KEY";
export const SET_STRIPE_CLIENT_ACCOUNT = "SET_STRIPE_CLIENT_ACCOUNT";
export const SET_PIXEL_KEYS = "SET_PIXEL_KEYS";
export const SET_STRIPE_CONNECT_ID = "SET_STRIPE_CONNECT_ID";
export const SET_ORGANIZATION_UUID = "SET_ORGANIZATION_UUID";

// Login actions
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const SENDING_LOGIN_REQUEST = "SENDING_LOGIN_REQUEST";
export const SET_AUTH = "SET_AUTH";

//  Flash messages actions
export const ENQUEUE_SNACKBAR = "ENQUEUE_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";

// get data content action
export const GET_INDEX_MEDIAS = "GET_INDEX_MEDIAS";

// Api call statuses
export const STATUSES = {
  STARTED: "STARTED",
  SUCCESSFUL: "SUCCESSFUL",
  FAILED: "FAILED",
};

// Void action, it should not be used in the reducers
export const RESET_PROJECT = "RESET_PROJECT";

export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export const SET_PROJECT_LANGUAGES = "SET_PROJECT_LANGUAGES";
export const SET_UPLOAD_STATUS = "SET_UPLOAD_STATUS";
export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
